import {Brick, ErrorFlow, registerBrick} from 'olympe';

/**
 * This brick merge the result of two calls: Olympe Gateway for occ. and MD API for names
 */
export default class MergeTaxCodeNamesAndOccurrences extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} taxCodeNames
     * @param {string} taxCodeOccurrences
     * @param {function(string)} setMergedTaxCode
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [taxCodeNames, taxCodeOccurrences], [setMergedTaxCode, setErrorFlow]) {
        try {
            const tcOcc = JSON.parse(taxCodeOccurrences);
            const tcNames = JSON.parse(taxCodeNames);

            if (tcOcc.length > 0 ) {
                const formattedData = [...tcOcc.reduce((mp, o) => { // Count duplicates from the API
                    if (!mp.has(o.mwskz)) {
                        mp.set(o.mwskz, {...o, count: 0});
                    }
                    mp.get(o.mwskz).count++;
                    return mp;
                }, new Map).values()]
                    .map((item) => {
                        return {
                            label: `${item.mwskz} - ${tcNames.find((tc) => tc.PurchsCode === item.mwskz)?.NameVAT ?? ''}`,
                            value: item.mwskz,
                            count: item.count,
                        };
                    })
                    .sort((a, b) => b.count - a.count);
                setMergedTaxCode(JSON.stringify(formattedData));
            } else {
                setMergedTaxCode('[]');
            }
        } catch (e) {
            setErrorFlow(ErrorFlow.create('Cannot merge tax code names and occ.', 1001));
        }
    }
}

registerBrick('0189ba7163e83458c947', MergeTaxCodeNamesAndOccurrences);
